import { Button, Grid, Menu, MenuList, useTheme } from '@mui/material';
import React, { useState } from 'react';
import { CirclePicker } from 'react-color';

import { useSnapshot } from 'features/snapshots/api/getSnapshot';
import { useUpdateSnapshot } from 'features/snapshots/api/updateSnapshot';

interface Props {
  snapshotId: number;
  disabled?: boolean;
}

const ColorPicker = ({ snapshotId, disabled }: Props) => {
  const theme = useTheme();
  const { data: snapshot } = useSnapshot({ snapshotId });
  const updateSnapshotMutation = useUpdateSnapshot({});
  const [pickerAnchor, setPickerAnchor] = useState<null | Element>(null);
  const handleButtonClick = (event: React.MouseEvent) => {
    if (!pickerAnchor) setPickerAnchor(event.currentTarget);
    else setPickerAnchor(null);
  };
  const handleClose = () => {
    setPickerAnchor(null);
  };
  const handleChange = async (color: { hex: string }) => {
    if (color.hex.toLowerCase() === '#2b3640')
      await updateSnapshotMutation.mutateAsync({
        data: {
          border_color: null,
        },
        snapshotId: snapshotId,
      });
    else
      await updateSnapshotMutation.mutateAsync({
        data: {
          border_color: color.hex,
        },
        snapshotId: snapshotId,
      });
  };
  let buttonColor = theme.palette.primary[800];
  if (
    snapshot?.border_color &&
    snapshot?.border_color.toLowerCase() !== '#2b3640'
  )
    buttonColor = snapshot.border_color;

  return (
    <Grid item container alignItems='center' style={{ height: '100%' }}>
      <Grid item>
        <Button
          variant='contained'
          onClick={handleButtonClick}
          sx={{
            backgroundColor: buttonColor,
            '&:hover': { backgroundColor: snapshot?.border_color },
          }}
          disabled={disabled}
        >
          Set Border Color
        </Button>
      </Grid>
      <Menu
        id='color-select'
        open={!!pickerAnchor}
        anchorEl={pickerAnchor}
        onClose={handleClose}
      >
        <MenuList style={{ padding: '1rem', paddingBottom: 0 }}>
          <CirclePicker
            color={snapshot?.border_color ? snapshot?.border_color : undefined}
            colors={[
              '#555555',
              '#f78da7',
              '#9c27b0',
              '#673ab7',
              '#3f51b5',
              '#2196f3',
              '#03a9f4',
              '#00bcd4',
              '#009688',
              '#4caf50',
              '#8bc34a',
              '#cddc39',
              '#607d8b',
              '#ffc107',
              '#ff9800',
              '#ff6900',
              '#795548',
              '#c2ab67',
            ]}
            onChange={handleChange}
          ></CirclePicker>
          <Grid
            container
            justifyContent='flex-end'
            style={{ marginTop: '.3rem' }}
          >
            <Grid item>
              <Button
                onClick={() => {
                  handleChange({ hex: '#2B3640' });
                }}
              >
                Clear Border
              </Button>
            </Grid>
          </Grid>
        </MenuList>
      </Menu>
    </Grid>
  );
};

export default ColorPicker;
